import styled from '@emotion/styled'
import { Button as MuiButton, Typography } from '@mui/material'
import { Grid, spacing, SpacingProps } from '@mui/system'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import useLoggedInUser from '@/hooks/useLoggedInUser'
import useT from '@/i18n/useT'

interface ButtonProps extends SpacingProps {
  component?: React.ElementType
  to?: string
  target?: string
}

const Button = styled(MuiButton)<ButtonProps>(spacing)

const Wrapper = styled.div`
  text-align: center;
`

function Page404() {
  const { handleLogout } = useLoggedInUser()
  const { t } = useT()
  return (
    <Wrapper>
      <Helmet title={t('404.title')} />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        404
      </Typography>
      <Typography component="h2" variant="h4" align="center" gutterBottom>
        {t('404.subtitle')}
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        {t('404.description')}
      </Typography>
      <Grid container spacing={2} direction={'column'}>
        <Button
          component={Link}
          to="/"
          variant="contained"
          color="primary"
          fullWidth={false}
          mt={2}
        >
          {t('404.returnToWebsite')}
        </Button>
        <Button
          component={Link}
          variant="contained"
          color="secondary"
          fullWidth={false}
          mt={2}
          onClick={handleLogout}
        >
          {t('404.logout')}
        </Button>
      </Grid>
    </Wrapper>
  )
}

export default Page404
